/**
 * File: AslAudioController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class AslAudioController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state,  $timeout,CQuesConst,CONSTANTS,Upload,$sce,uploadService) {
        var MQ = MathQuill.getInterface(2);
        let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
        let userId = localStorageService.get("user_id")
        let USER_PATH = userId + "/asl/"
        let schoolId = localStorageService.get("school_id")
        let ASL_ANS_TYPE=CQuesConst.ASL_ANS_TYPE
        let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
        let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
        let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
        let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
        let SAVE_URL = CQuesConst.API_CREATE_DRAW
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Archives"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            
            $scope.index = this.index
            $scope.quesId = "text-question" + $scope.index;
            $scope.voiceIndex = $scope.index + 1
            if ($scope.$parent.editQuestions[$scope.index]) {
                let currentQuestion = $scope.$parent.editQuestions[$scope.index]
                if (currentQuestion) {
                    if (currentQuestion.qn_desc) {
                        $scope.question = currentQuestion.qn_desc;
                        $scope.isLatex = currentQuestion.isLatex;
                    }
                    if (currentQuestion.answer) {
                        $scope.ans_audio_url = currentQuestion.answer
                        let src = PREVIEW_URL + $scope.ans_audio_url
                        $scope.playableAnswerUrl = $sce.trustAsResourceUrl(src)
                    }
                }

            }
        }
        //On destroy function
        this.$onDestroy = () => {
        }
        $scope.loadLatexSelection = function(){
            $timeout(() => {
                $scope.isLatex = false
            })
        }

        $timeout(() => {
            var MQ = MathQuill.getInterface(2);
            var textQuestion = document.getElementById("text-question" + $scope.index);
            textQuestion.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
            if ($scope.question !== undefined) {
                textQuestion.textContent = $scope.question
            }
            var mathField = MQ.MathField(textQuestion, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function() {
                        $scope.question = mathField.latex()
                    }
                }
            })
        }, 10);

        /*
         * Function to upload audio
         *
         * @return : null
         */
        $scope.uploadAudio = (file) => {
            if (fileValidate(file)) {
                let user_id = userId
                Upload.upload({
                    url: UPLOAD_URL,
                    data: {
                        file: file,
                        'userPath': USER_PATH
                    }
                }).then(function(resp) {
                    updateAudioUrl(resp.data)
                })
            }
        }

        /*
         * Function to upload audio
         *
         * @return : null
         */
        function updateAudioUrl(url) {
            $scope.ans_audio_url = url;
            let src = PREVIEW_URL + url
            $scope.playableAnswerUrl = $sce.trustAsResourceUrl(src)
            $scope.isLoading = true
            toastr.success("Audio uploaded successfully...")
        }

        /*
         * Function to validate audio files
         *
         * @file : uploaded file
         *
         * @return : Boolean - validity of file
         */
        function fileValidate(file) {
            let supportedFrmts = ['mp3', 'wav']
            let isValid = false

            if (file && !file.$error && file !== undefined && file !== null) {
                let fileSize = ((file.size) / 1048576)
                let extValue = file.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    // if (file.type === "audio/mp3" || file.type === "audio/wav") {
                    if (fileSize < 6.00) {
                        if (file.name !== "") {
                            $scope.isLoading = false;
                            isValid = true;
                        } else {
                            $scope.isLoading = true;
                            toastr.error("File is not valid")
                            isValid = false
                        }
                    } else {
                        $scope.isLoading = true;
                        toastr.error("Please upload audio file size less than 6MB")
                        isValid = false
                    };
                } else {
                    $scope.isLoading = true;
                    toastr.error('Please select supported mp3 or wav file formats.')
                    isValid = false
                }
            }
            return isValid
        }

        /*
         * Function to add to list
         *
         * @return : null
         */
        $scope.addToList = () => {
            $scope.errors = {}
            let errCount = 0;
            if ($scope.question === undefined || $scope.question === "") {
                $scope.errors.question = "Please Enter Question"
                errCount++;
            }else if($scope.question.length>500){
                $scope.errors.question="Question must not exceed 500 characters"
                errCount++;
            }

            // if ($scope.ans_audio_url === undefined || $scope.ans_audio_url === "") {
            //     $scope.errors.ans_audio_url = "Please Upload or record sample audio answer"
            //     errCount++;
            // }
            if (errCount == 0) {
                let obj = {
                    type: ASL_ANS_TYPE.AUDIO,
                    qn_desc: $scope.question,
                    isLatex: $scope.isLatex,
                    answer: $scope.ans_audio_url
                }
                $scope.question = "";
                $scope.isLatex = false
                $scope.ans_audio_url = "";
                $scope.$parent.addToList(obj, $scope.index)
            }
        }

        /*
         * Function to save recorded file url
         *
         * @url : uploaded file url
         *
         * @return : null
         */
        $scope.saveRecordedUrl = (url) => {
            updateAudioUrl(url)
        }

        $scope.paste = function(e){
           e.preventDefault();
           return false
        }

    }
}

export default AslAudioController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/aslAudioController.js